import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as viewReducer from "containers/View/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";

import ChatAppView from "components/ChatApp/ChatAppView";

class ChatAppViewContainer extends React.PureComponent {
  render() {
    return <ChatAppView {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleDelete: (id) => dispatch(blueprintReducer.handleDelete(id)),

    initEmailApp: () => dispatch(chatGPTReducer.initEmailApp()),
    initChatApp: (chatApp) => dispatch(chatGPTReducer.initChatApp(chatApp)),
    initCreateApp: () => dispatch(chatGPTReducer.initCreateApp()),
    initImportApp: () => dispatch(chatGPTReducer.initImportApp()),

    updateViewType: (viewType) => dispatch(viewReducer.updateType(viewType))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    chatApps: viewReducer.getChatApps(state, true, "STANDARD_AND_AZ"),
    searchText: viewReducer.getSearch(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ChatAppViewContainer);
